import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Contents, DropdownMenu, Overlay} from "../../../components";
import {useRecoilState, useRecoilValue} from "recoil";
import {isAdmin, subMenuState} from "../../../../state";
import {SpacingV} from "../../InstructorApp/component/common/Spacing";
import {constCommon} from "../../../../constants";
import {
    AddChapter,
    Col, ContentsHeader,
    FormBox,
    ProfileFormBoxItemWrap,
    FormItem,
    Radio,
    RadioButton,
    Row, SwitchContainer, SwitchInput, SwitchItems, SwitchLabel, SwitchSlider
} from "../../../../styled/StyledComponent";
import PlusIcon from "../../../../assets/images/icon/PlusIcon";
import AutoComplete from "../../InstructorApp/component/common/AutoComplete";
import DateIcon from "../../../../assets/images/icon/DateIcon";
import DeleteIcon from "../../../../assets/images/icon/DeleteIcon";
import RemoveGrey from "../../../../assets/images/icon/RemoveGrey";
import {teachersAPI} from "../../../../api/teachersAPI";
import {cloneDeep} from "lodash";
import {isEmpty} from "../../../../util";
import dayjs from "dayjs";
import {commonAPI} from "../../../../api/commonAPI";
import CloseIcon from "../../../../assets/images/icon/CloseIcon";
import hashIt from "hash-it";
import ProfileUrlPopup from "../components/ProfileUrlPopup";
import EditIcon from "../../../../assets/images/icon/EditIcon";
import {FaUser} from "react-icons/fa6";
import {CheckBox} from "../../../components/common/CheckBox";
import CloseGrey from "../../../../assets/images/icon/CloseGrey";
import {usersAPI} from "../../../../api/usersAPI";
import {classNames} from "react-select/dist/declarations/src/utils";

const eduObj = {
    "degreeType1": "",
    "degreeType2": "",
    "description": "",
    "endedDate": "",
    "schoolName": "",
    "startedDate": "",
};

const expObj = {
    "companyName": "",
    "description": "",
    "endDate": "",
    "position": "",
    "startDate": "",
};

const dataArr = ["aboutTheAuthor", "blogUrl", "name", "profileUrl", "publicJobTitle", "resume"]
const AuthorProfile = (props) => {
  const [subMenu, setSubMenu] = useRecoilState(subMenuState);
  const [info, setInfo] = useState(null);
  const [aboutTheAuthor, setAboutTheAuthor] = useState(null);
  const [blogUrl, setBlogUrl] = useState(null);
  const [instructorName, setInstructorName] = useState("")
  const [profileUrl, setProfileUrl] = useState("")
  const [publicJobTitle, setPublicJobTitle] = useState("")
  const [resume, setResume] = useState(null);
  const [edu, setEdu] = useState([]);
  const [exp, setExp] = useState([]);
  const [skill, setSkill] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [degreeList, setDegreeList] = useState([]);
  const [urlPopup, setUrlPopup] = useState(false);
  const [uploadFileUrl ,setUploadedFileUrl] = useState(null);
  const [imgFile, setImgFile] = useState(null);
  const [imgPopup, setImgPopup] = useState(false);
  const [imgDisplay, setImgDisplay] = useState("block");
  const [warnBtn, setWarnBtn] = useState("");
  const [warnTitle, setWarnTitle] = useState("");
  const [warnPopup, setWarnPopup] = useState(false);
  const [warnType, setWarnType] = useState("ban");
  const [completed, setCompleted] = useState(false);
  const getJobList = async () => {
        await commonAPI.getJobList(null).then((res) => {
            console.log("jobList", res);
            const list = cloneDeep(res?.data);
            setJobList(list);
        });
  };
 const getDegreeList = async () => {
    await commonAPI.getDegreeList(null).then((res) => {
        console.log("degreeList", res);
        const list = cloneDeep(res?.data);
        setDegreeList(list);
    });
 };

 const isAdminState = useRecoilValue(isAdmin);
 const getProfile = async () => {
     if(isAdminState){
       await teachersAPI.getTeacherProfileByAdmin(props.id)
            .then(res => {
                setInfo(res?.data)
                setAboutTheAuthor(res?.data?.aboutTheAuthor);
                setBlogUrl(res?.data?.blogUrl)
                setInstructorName(res?.data?.name)
                setProfileUrl(res?.data?.profileUrl)
                setPublicJobTitle(res?.data?.publicJobTitle)
                setResume(res?.data?.resume)
                setEdu(isEmpty(res?.data?.resume?.education) ? [eduObj] : cloneDeep(res?.data?.resume?.education))
                setExp( isEmpty(res?.data?.resume?.experience) ? [expObj] : cloneDeep(res?.data?.resume?.experience))
                setSkill(isEmpty(res?.data?.resume?.skillAndCertificates) ? [""] : res?.data?.resume?.skillAndCertificates);

            })
    
     }else{
         await teachersAPI.getTeacherProfile()
             .then(res => {
                 console.log("@user",res);
                 setInfo(res?.data)
                 setAboutTheAuthor(res?.data?.aboutTheAuthor);
                 setBlogUrl(res?.data?.blogUrl)
                 setInstructorName(res?.data?.name)
                 setProfileUrl(res?.data?.profileUrl)
                 setPublicJobTitle(res?.data?.publicJobTitle)
                 setResume(res?.data?.resume)
                 setEdu(isEmpty(res?.data?.resume?.education) ? [eduObj] : cloneDeep(res?.data?.resume?.education))
                 setExp( isEmpty(res?.data?.resume?.experience) ? [expObj] : cloneDeep(res?.data?.resume?.experience))
                 setSkill(isEmpty(res?.data?.resume?.skillAndCertificates) ? [""] : res?.data?.resume?.skillAndCertificates);
             })
     }
  };

  const h = hashIt({
        aboutTheAuthor,
        blogUrl,
        instructorName,
        profileUrl,
        publicJobTitle,
        edu,
        exp,
        skill,
        jobList,
        degreeList
  });

  const patchProfile = async (data = null) => {
      await teachersAPI.patchProfile({
          data:data === null ?  {
              aboutTheAuthor:aboutTheAuthor,
              blogUrl:blogUrl,
              instructorName:instructorName,
              // profileUrl:`www.linkedin.com/in/${profileUrl}`,
              profileUrl:profileUrl,
              publicJobTitle:publicJobTitle,
              resume:{
                  education: cloneDeep(edu),
                  experience: cloneDeep(exp),
                  skillAndCertificates: cloneDeep(skill).filter(item => !isEmpty(item))
              }
          }: cloneDeep(data)
      })
          .then((res) => {
              getProfile()
          })
  }

  const putProfile = async () => {
      await usersAPI.putInstructorProfile(props?.id,{
          data: {
              aboutTheAuthor:aboutTheAuthor,
              blogUrl:blogUrl,
              instructorName:instructorName,
              // profileUrl:`www.linkedin.com/in/${profileUrl}`,
              profileUrl:profileUrl,
              publicJobTitle:publicJobTitle,
              resume:{
                  education: cloneDeep(edu),
                  experience: cloneDeep(exp),
                  skillAndCertificates: cloneDeep(skill).filter(item => !isEmpty(item))
              }
          }
      })
          .then((res) => {
              getProfile()
          })
  }

  const putStatus = async (status:boolean) => {
      putProfile()
          .then(async res => {
              await usersAPI.putInstructorStatus(props.id,{
                  data:{
                      verification:status,
                      updates:info?.updates,
                      withDraw:info?.accessStatusEntity?.withdraw,
                      banned:info?.accessStatusEntity?.banned,
                  }
              })
                  .then(res => {
                      getProfile();
                      setWarnPopup(false);
                  })
          })

  }

  const putWithdraw = async (status) => {
      putProfile()
          .then(async res => {
              await usersAPI.putInstructorStatus(props.id,{
                  data:{
                      verification:info?.verification,
                      updates:info?.updates,
                      withDraw:status,
                      banned:info?.accessStatusEntity?.banned,
                  }
              })
                  .then(res => {
                      getProfile();
                      setWarnPopup(false);
                  })
          })
  }
  
  console.log("@hash",h);

  const getFormData = (file:any) => {
    const formData = new FormData();
      const thumbnailBlob = new Blob([file], {
          type: file?.type,
      });
      formData.append("file", thumbnailBlob, file?.name);
    return formData;
 };
  const updateProfileImg = async (file:any) => {
      await teachersAPI.postProfileImg({
            data:getFormData(file)
      })
          .then(res => {
              getProfile();

          })
  }

  const onChangeData = (state, index, property, setState, value) => {
      const c = cloneDeep(state);
      c[index][property] = value;
      setState(cloneDeep(c));
  };

  const handleFileChange = (event) => {
        const file = event.target.files[0];
        setImgFile(file);
        if (file) {
            // 파일에 대한 URL 생성
            const fileUrl = window.URL.createObjectURL(file);
            setUploadedFileUrl(fileUrl);
        }
  };

  const itemRef = useRef(null);
  useEffect(() => {
      itemRef.current = patchProfile
      return () => {
          console.log("@h",h);
      }
  }, [h]);

  useEffect(() => {
    document.addEventListener("keydown",(e)=>{
        if(e.keyCode === 27){
            setImgPopup(false)
        }
    })
  }, []);

  useLayoutEffect(()=>{
      getProfile();
      getJobList();
      getDegreeList();

      return () =>{
          itemRef.current();
      }
  },[]);


return(
  <Container
      className={isAdminState ? "admin" : ""}
      onSubmit={(e)=>{
      e.preventDefault();
      if(isAdminState){
          putProfile()
      }else{
          patchProfile();
      }
  }}
  >
      {
          isAdminState &&
          <>
              <Contents title={"Instructor Details"}>
                  <ContentsInner>
                      <ProfileHeader>
                          <HeaderContents>
                              <Row display={"flex"} style={{width:"100%"}}>
                                  <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                      <FormBox>
                                          <dt>
                                              First Name
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input type="text"
                                                                 required={true}
                                                                 value={info?.firstName}
                                                                 onChange={(e) => {
                                                                     setInstructorName(e.target.value)
                                                                 }}
                                                          />
                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                                  <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                      <FormBox>
                                          <dt>
                                              Last Name
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input
                                                              value={info?.lastName}
                                                              required={true}

                                                              readOnly={true}
                                                              type="text"
                                                          />
                                                          <div
                                                              onClick={()=>{
                                                                  setUrlPopup(true)
                                                              }}
                                                              className="editIcon" style={{cursor:"pointer"}}>
                                                          </div>

                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                                  <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                      <FormBox>
                                          <dt>
                                              Whoflex Name
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input
                                                              required={true}
                                                              value={info?.nickName}
                                                              readOnly={true}
                                                              type="text"
                                                              placeholder={"Whoflex Name"}
                                                          />
                                                          <div
                                                              onClick={()=>{
                                                                  setUrlPopup(true)
                                                              }}
                                                              className="editIcon" style={{cursor:"pointer"}}>

                                                          </div>

                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                              </Row>
                              <Row display={"flex"} style={{width:"100%"}}>
                                  <Col style={{width:"calc((100% - 15px) / 2)"}}>
                                      <FormBox>
                                          <dt>
                                              Email
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input
                                                              required={true}
                                                              value={info?.email}
                                                              readOnly={true}
                                                              type="text"/>
                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                                  <Col style={{width:"calc((100% - 15px) / 2)"}}>
                                      <FormBox>
                                          <dt>
                                              Password
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input
                                                              readOnly={true}
                                                              // value={publicJobTitle}
                                                              // onChange={(e) => {
                                                              //     setPublicJobTitle(e.target.value)
                                                              // }}
                                                              placeholder={"Password"}
                                                              type="text" />
                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                              </Row>
                          </HeaderContents>
                      </ProfileHeader>
                      <RowWrap>
                          <ContentBox style={{width:"78%", paddingRight:0, marginRight:15}}>

                              <Row display={"flex"} style={{width:"100%"}}>
                                  <Col style={{minWidth:"56%", width:"56%", marginRight:15}}>
                                      <FormBox>
                                          <dt>
                                              Registration Date
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input
                                                              value={info?.adminAccessDateTime}
                                                              required={true}
                                                              readOnly={true}
                                                              type="text"/>
                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>

                                  <Col>
                                      <FormBox>
                                          <dt>
                                              Last Access Date
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input
                                                              value={info?.accessInfo?.datetime}
                                                              required={true}
                                                              readOnly={true}
                                                              type="text"/>
                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                              </Row>
                              <Row display={"flex"} style={{width:"100%"}}>
                                  <Col style={{width:"56%", marginRight:15}}>
                                      <FormBox>
                                          <dt>
                                              Withdrawal Date
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <FormItem>
                                                          <input
                                                              readOnly={true}
                                                              value={info?.accessStatusEntity?.withdraw ? info?.accessStatusEntity?.withdrawDatetime : ""}
                                                              type="text"/>
                                                          <div
                                                              onClick={() => {
                                                                  // setUrlPopup(true)
                                                              }}
                                                              className="editIcon" style={{cursor: "pointer"}}>
                                                              {/*<EditIcon/>*/}

                                                              <SwitchItems style={{paddingRight: 10}}>
                                                                  {/*<span>*/}
                                                                  {/*    {textTransform()?.capitalizeFirstLetter(String(item?.type)?.toLocaleLowerCase())}*/}
                                                                  {/*</span>*/}
                                                                  <SwitchContainer>
                                                                      <SwitchLabel
                                                                          isOn={info?.accessStatusEntity?.withdraw}>
                                                                          <SwitchInput type="checkbox"
                                                                                       checked={false}
                                                                                       onChange={async () => {
                                                                                           setWarnType("withdraw")
                                                                                           setWarnPopup(true);
                                                                                           setWarnTitle("Change User Withdraw Status");
                                                                                           setWarnBtn(info?.accessStatusEntity?.withdraw ? "Restore User" : "Withdraw")
                                                                                       }}/>
                                                                          <SwitchSlider
                                                                              isOn={info?.accessStatusEntity?.withdraw}/>
                                                                      </SwitchLabel>
                                                                  </SwitchContainer>
                                                              </SwitchItems>
                                                          </div>
                                                      </FormItem>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                                  <Col style={{width: "40%",}}>
                                      <FormBox>
                                          <dt>
                                              Verification
                                          </dt>
                                          <dd>
                                              <ProfileFormBoxItemWrap>
                                                  <li>
                                                      <Radio style={{height: 40}}>
                                                          <RadioButton
                                                              onClick={() => {
                                                                  if(info?.verification !== true) {
                                                                      setWarnType("verification")
                                                                      setWarnPopup(true)
                                                                      setWarnTitle("Change Verification Status")
                                                                      setWarnBtn("Verified")
                                                                  }
                                                                  // updateReqData("accept", true)

                                                              }}
                                                              className={info?.verification === true ? "on" : ""}
                                                          >
                                                              <div className="circle"></div>
                                                              <span>
                                                    Verified
                                                        </span>
                                                          </RadioButton>
                                                          <RadioButton
                                                              style={{marginLeft: 56}}
                                                              onClick={async () => {
                                                                  // updateReqData("accept", false)
                                                                  await putStatus(false)
                                                              }}
                                                              className={info?.verification === false ? "on" : ""}>
                                                          <div className="circle"></div>
                                                              <span>
                                                    Not Yet
                                                </span>
                                                          </RadioButton>
                                                      </Radio>
                                                  </li>
                                              </ProfileFormBoxItemWrap>
                                          </dd>
                                      </FormBox>
                                  </Col>
                              </Row>
                          </ContentBox>
                          <RowContents>
                              <img src={"/images/gotoProfile.png"}/>
                              <svg width="131" height="1" viewBox="0 0 131 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                      d="M130.37 0.489908C130.37 0.532849 101.186 0.569659 65.1883 0.569659C29.191 0.569659 0 0.532849 0 0.489908C0 0.446966 29.1787 0.410156 65.1883 0.410156C101.198 0.410156 130.37 0.446966 130.37 0.489908Z"
                                      fill="#333333"/>
                              </svg>

                              <span>Go to Profile</span>
                              <a href={`https://www.whoflex.com/instructors/${profileUrl}`} target={"_blank"}></a>
                          </RowContents>
                      </RowWrap>
                  </ContentsInner>
              </Contents>
              <SpacingV height={20}/>
          </>
      }

      {
          urlPopup &&
          <Overlay filter={true}>
              <ProfileUrlPopup
                  value={profileUrl}
                  onClickPopup={() => {
                      setUrlPopup(false)
                  }}
                  onChange={(e)=>{
                      setProfileUrl(e.target.value)
                  }}
                onClickSave={async ()=>{
                    // await teachersAPI.getTeacherUrlCheck(profileUrl)
                    //     .then(res => {
                    //         console.log("@res",res);
                    //     })
                    await teachersAPI.patchProfile({
                        data: {
                            aboutTheAuthor:aboutTheAuthor,
                            blogUrl:blogUrl,
                            instructorName:instructorName,
                            // profileUrl: `www.whoflex.com/instructors/${profileUrl}`,
                            profileUrl:profileUrl,
                            publicJobTitle:publicJobTitle,
                            resume:{
                                education: cloneDeep(edu),
                                experience: cloneDeep(exp),
                                skillAndCertificates: cloneDeep(skill).filter(item => !isEmpty(item))
                            }
                        }
                    })
                        .then((res) => {
                            getProfile()
                        })
                }}
              />
          </Overlay>
      }
      {
          imgPopup &&
          <Overlay filter={true} >
              <ImgPopup style={{width: 450}} className={imgPopup ? "on" : ""}>
                  <ContentsHeader>
                      Profile picture
                  </ContentsHeader>
                  <ImgPopupItem>
                      {
                          info?.profileImage?.fileName !== 'blob' ?
                              <img src={info?.profileImage?.url} alt=""/> : <FaUser className={"userIcon"}/>
                      }
                      <input type="file" onChange={async (e) => {
                          await updateProfileImg(e.target.files[0])
                          e.target.value = ""
                      }}/>

                  </ImgPopupItem>
                  <div className="btns">
                  <span
                      onClick={async (e) => {
                          setImgFile(null)
                          setUploadedFileUrl(null);
                          await updateProfileImg(null)
                              .then(res => {
                                  setImgPopup(false)
                              })
                      }
                      }
                  >Delete image</span>
                  <div className="inputItem">
                     <span
                         // style={{
                         //     opacity: imgFile === null ? 0.5 : 1,
                         // }}
                         // onClick={async (e) => {
                         //     await updateProfileImg(imgFile)
                         //         .then(res => {
                         //             setImgPopup(false)
                         //         })
                         // }}
                         className={"uploadBtn"}>Upload image</span>
                      <input type="file" onChange={async (e)=>{
                          await updateProfileImg(e.target.files[0])
                          e.target.value = ""
                      }}/>
                  </div>
                  </div>
                  <div className="close" onClick={()=>{setImgPopup(false)}}>
                      <CloseIcon/>
                  </div>
              </ImgPopup>
          </Overlay>
      }
      {/*rgb(162, 191, 254)*/}
      {
          warnPopup &&
          <Overlay filter={false}>
              <WarnPopup>
                  <ContentsHeader style={{background:warnType === "withdraw" ? "#EB5757" : "#A2BFFE", color:"#fff"}}>
                      {warnTitle}
                  </ContentsHeader>
                  <p>
                      Are you sure to continue?
                  </p>
                  <PopupBtn>
                            <span
                                onClick={()=>{
                                    setWarnPopup(false)
                                }}
                            >
                                Cancel
                            </span>
                      <span
                          onClick={async ()=>{

                              if(warnType === "withdraw") {
                                 await putWithdraw(!info?.accessStatusEntity?.withdraw)
                              }else {
                                 await putStatus(true)
                              }
                          }}
                          style={{background:"#333", color:"#fff"}}>
                                {warnBtn}
                            </span>
                  </PopupBtn>
              </WarnPopup>
          </Overlay>
      }
      <Contents title={"Author Profile"}>
          <ContentsInner>
              <ProfileHeader>
                  <Thumb>
                      <dt>
                          Profile
                      </dt>
                      <Img onClick={() => {
                          setImgPopup(true)
                      }}>
                          {
                              info?.profileImage?.fileName !== 'blob' ?
                                  <img src={info?.profileImage?.url}
                                       style={{
                                           display:!isEmpty(info?.profileImage?.url) ? "flex" : "none"
                                       }}
                                       alt=""/> : <FaUser className={"userIcon"} />
                        }
                        {/*<input*/}
                        {/*    onChange={async (e)=>{*/}
                        {/*       await updateProfileImg(e.target.files[0])*/}
                        {/*    }}*/}
                        {/*    type="file"/>*/}
                          <div className="cam">
                              <svg width="20" height="18" viewBox="0 0 20 18" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                  <path
                                      d="M17.5112 3.06854H14.763L14.443 2.10987C14.2888 1.64438 13.9914 1.23935 13.5932 0.952473C13.195 0.665592 12.7164 0.51148 12.2254 0.512087H8.27148C7.78062 0.511712 7.30215 0.665923 6.90413 0.952782C6.5061 1.23964 6.2088 1.64454 6.05452 2.10987L5.73388 3.06854H2.98572C2.36604 3.06921 1.77194 3.31534 1.33376 3.75291C0.895581 4.19048 0.649115 4.78376 0.648438 5.40258V14.7975C0.649792 15.4159 0.896557 16.0085 1.33466 16.4455C1.77277 16.8826 2.36648 17.1283 2.98572 17.129H17.5137C18.133 17.1277 18.7264 16.8812 19.164 16.4437C19.6016 16.0062 19.8478 15.4133 19.8484 14.795V5.40002C19.8471 4.78164 19.6003 4.18902 19.1622 3.752C18.7241 3.31498 18.1304 3.06921 17.5112 3.06854ZM18.5684 14.795C18.5681 15.0749 18.4566 15.3432 18.2584 15.5412C18.0602 15.7391 17.7915 15.8504 17.5112 15.8508H2.98572C2.70541 15.8504 2.43669 15.7391 2.23848 15.5412C2.04028 15.3432 1.92878 15.0749 1.92844 14.795V5.40002C1.92945 5.12055 2.04125 4.85285 2.23938 4.65547C2.43752 4.45809 2.70586 4.3471 2.98572 4.34676H6.19532C6.32959 4.34666 6.46042 4.30439 6.56931 4.22594C6.67819 4.14748 6.75961 4.03682 6.80204 3.90961L7.2686 2.51187C7.33866 2.30163 7.47325 2.11877 7.65327 1.98925C7.8333 1.85973 8.0496 1.79012 8.27148 1.79031H12.2254C12.4474 1.79007 12.6638 1.85973 12.8438 1.98939C13.0239 2.11905 13.1584 2.3021 13.2283 2.51251L13.6948 3.90961C13.7373 4.03682 13.8187 4.14748 13.9276 4.22594C14.0365 4.30439 14.1673 4.34666 14.3016 4.34676H17.5112C17.7915 4.3471 18.0602 4.45845 18.2584 4.65638C18.4566 4.85431 18.5681 5.12266 18.5684 5.40258V14.795Z"
                                      fill="#333333"/>
                                  <path
                                      d="M10.2492 4.98645C9.29987 4.98645 8.37184 5.26757 7.58248 5.79427C6.79313 6.32097 6.1779 7.06959 5.8146 7.94546C5.4513 8.82133 5.35624 9.78511 5.54145 10.7149C5.72666 11.6447 6.18382 12.4988 6.85511 13.1692C7.5264 13.8396 8.38168 14.2961 9.31279 14.481C10.2439 14.666 11.209 14.5711 12.0861 14.2083C12.9632 13.8455 13.7128 13.2311 14.2403 12.4428C14.7677 11.6546 15.0492 10.7278 15.0492 9.77979C15.0479 8.50893 14.5417 7.29052 13.6418 6.39188C12.742 5.49325 11.5218 4.9878 10.2492 4.98645ZM10.2492 13.2949C9.55303 13.2949 8.87247 13.0888 8.29361 12.7025C7.71475 12.3163 7.26359 11.7673 6.99717 11.125C6.73074 10.4827 6.66104 9.77589 6.79686 9.09403C6.93268 8.41216 7.26792 7.78583 7.7602 7.29423C8.25249 6.80263 8.87969 6.46785 9.5625 6.33222C10.2453 6.19659 10.9531 6.2662 11.5963 6.53225C12.2395 6.7983 12.7892 7.24884 13.176 7.8269C13.5628 8.40496 13.7692 9.08457 13.7692 9.77979C13.7682 10.7117 13.397 11.6052 12.7371 12.2642C12.0772 12.9232 11.1825 13.2939 10.2492 13.2949Z"
                                      fill="#333333"/>
                                  <path
                                      d="M16.6478 6.90396C17.0013 6.90396 17.2878 6.61782 17.2878 6.26484C17.2878 5.91187 17.0013 5.62573 16.6478 5.62573C16.2944 5.62573 16.0078 5.91187 16.0078 6.26484C16.0078 6.61782 16.2944 6.90396 16.6478 6.90396Z"
                                      fill="#333333"/>
                              </svg>
                          </div>
                      </Img>
                  </Thumb>
                  <HeaderContents>
                      <Row display={"flex"} style={{width: "100%"}}>
                          <Col>
                              <FormBox>
                                  <dt>
                                      Instructor Name<strong>*</strong>
                                  </dt>
                                  <dd>
                                      <ProfileFormBoxItemWrap>
                                          <li>
                                              <FormItem>
                                                  <input type="text"
                                                         required={true}
                                                         value={instructorName}
                                                         onChange={(e) => {
                                                             setInstructorName(e.target.value)
                                                         }}
                                                         placeholder={"Enter your instructor name for Whoflex"}/>
                                              </FormItem>
                                          </li>
                                      </ProfileFormBoxItemWrap>
                                  </dd>
                              </FormBox>
                          </Col>
                          <Col>
                              <FormBox>
                                  <SpacingV className={"mobile"} height={15} />
                                  <dt>
                                      Profile URL<strong>*</strong>
                                  </dt>
                                  <dd>
                                      <ProfileFormBoxItemWrap>
                                          <li>
                                              <FormItem>
                                                  <input
                                                      required={true}
                                                      value={`www.whoflex.com/instructors/${profileUrl}`}
                                                      onChange={(e) => {
                                                          setProfileUrl(e.target.value)
                                                      }}
                                                      readOnly={true}
                                                      type="text"
                                                      placeholder={"Enter your instructor name for Whoflex"}/>
                                                  <div
                                                      onClick={() => {
                                                          setUrlPopup(true)
                                                      }}
                                                      className="editIcon" style={{cursor: "pointer"}}>
                                                      <EditIcon/>
                                                      <span style={{marginTop: 3}}>Edit</span>
                                                </div>

                                            </FormItem>
                                        </li>
                                    </ProfileFormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                    </Row>
                    <Row display={"flex"} style={{width:"100%"}}>
                        <Col style={{width:"100%"}}>
                            <FormBox>
                                <dt>
                                    Job Title<strong>*</strong>
                                </dt>
                                <dd>
                                    <ProfileFormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <input
                                                    required={true}
                                                    value={publicJobTitle}
                                                    onChange={(e) => {
                                                        setPublicJobTitle(e.target.value)
                                                    }}
                                                    type="text" placeholder={"Please explain your work"}/>
                                            </FormItem>
                                        </li>
                                    </ProfileFormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                    </Row>
                </HeaderContents>
            </ProfileHeader>
            <ContentBox>
                <Row display={"flex"} style={{width:"100%"}}>
                    <Col>
                        <FormBox>
                            <dt>
                                Website
                            </dt>
                            <dd>
                                <ProfileFormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <input
                                                value={blogUrl?.website}
                                                required={true}
                                                onChange={(e) => {
                                                    setBlogUrl({
                                                        ...blogUrl,
                                                        website:e.target.value
                                                    });
                                                }}
                                                type="text" placeholder={"Enter your website address"}/>
                                        </FormItem>
                                    </li>
                                </ProfileFormBoxItemWrap>
                            </dd>
                        </FormBox>
                    </Col>
                    <Col  >
                        <FormBox>
                            <SpacingV className={"mobile"} height={15} />
                            <dt>
                                Twitter
                            </dt>
                            <dd>
                                <ProfileFormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <input
                                                value={blogUrl?.twitter}
                                                required={true}
                                                onChange={(e) => {
                                                    setBlogUrl({
                                                        ...blogUrl,
                                                        twitter:e.target.value
                                                    });
                                                }}
                                                type="text" placeholder={"Enter your twitter username or url"}/>
                                        </FormItem>
                                    </li>
                                </ProfileFormBoxItemWrap>
                            </dd>
                        </FormBox>
                    </Col>
                </Row>
                <Row display={"flex"} style={{width:"100%", marginBottom:10}}>
                    <Col style={{width:"100%", }} >
                        <FormBox>
                            <dt>
                                About The Author<strong>*</strong>
                            </dt>
                            <dd>
                                <ProfileFormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <textarea
                                                required={true}
                                                value={aboutTheAuthor?.aboutTheAuthor}
                                                onChange={(e)=>{
                                                    setAboutTheAuthor({
                                                        ...aboutTheAuthor,
                                                        "aboutTheAuthor":e.target.value
                                                    })
                                                }}
                                                placeholder={"Introduce yourself to students so they can understand you and your work"} style={{resize:"none", height:120}} />
                                        </FormItem>
                                    </li>
                                </ProfileFormBoxItemWrap>
                            </dd>
                        </FormBox>
                    </Col>
                </Row>
                <Row display={"flex"} style={{width:"100%"}}>
                    <Col style={{width:"100%", }} >
                        <FormBox>
                            <dt>
                                A Word From The Author
                            </dt>
                            <dd>
                                <ProfileFormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <textarea
                                                required={true}
                                                value={aboutTheAuthor?.wordFromTheAuthor}
                                                onChange={(e)=>{
                                                    setAboutTheAuthor({
                                                        ...aboutTheAuthor,
                                                        "wordFromTheAuthor":e.target.value
                                                    })
                                                }}
                                                placeholder={"Write your goals and anything you want to say to students here"} style={{resize:"none", height:90}} />
                                        </FormItem>
                                    </li>
                                </ProfileFormBoxItemWrap>
                            </dd>
                        </FormBox>
                    </Col>
                </Row>
            </ContentBox>
        </ContentsInner>
    </Contents>

    <SpacingV height={20} />

    <Contents title={"Resume"}>
        <ContentsInner>
            <ContentBox>
                <h1>
                    Experience
                </h1>
            </ContentBox>
            <Experience>
                {
                    exp.map((item,index) => {
                        return(
                            <ExperienceItem className={index !== 0 ? "border" : ""}>
                                <ContentBox>
                                    <Row display={"flex"} style={{width:"100%"}}>
                                        <Col>
                                            <FormBox>
                                                <dt>
                                                    Company Name<strong>*</strong>
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <input type="text"
                                                                       required={true}
                                                                       value={item?.companyName}
                                                                       onChange={(e)=>{
                                                                           const value = e.target.value
                                                                           onChangeData(exp,index,"companyName", setExp, value)
                                                                       }}
                                                                       placeholder={"Enter your company name in which you work"}/>
                                                            </FormItem>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                            <div className="checkItem"
                                                onClick={()=>{
                                                    if(item?.isCurrent !== true) {
                                                        onChangeData(exp,index,"isCurrent", setExp, true)
                                                    }else {
                                                        onChangeData(exp,index,"isCurrent", setExp, false)
                                                    }
                                                }}
                                            >
                                                <CheckBox
                                                    onClick={()=>{
                                                        if(item?.isCurrent !== true) {
                                                            onChangeData(exp,index,"isCurrent", setExp, true)
                                                        }else {
                                                            onChangeData(exp,index,"isCurrent", setExp, false)
                                                        }
                                                    }}
                                                    state={item?.isCurrent === true}
                                                /> <span>I am currently working in the role here</span>
                                            </div>

                                        </Col>
                                        <Col>
                                            <FormBox>
                                                <SpacingV className={"mobile"} height={15} />
                                                <dt>
                                                    Position<strong>*</strong>
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <AutoComplete
                                                                options={cloneDeep(jobList)}
                                                                placeholder={"Please enter your position (e.g Digital Marketing)"}
                                                                value={item?.position}
                                                                formType={true}
                                                                onChange={(value)=>{
                                                                    onChangeData(exp,index,"position", setExp, value)
                                                                }}
                                                            />
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>

                                    </Row>

                                    <Row display={"flex"} style={{width:"100%"}}>
                                        <Col>
                                            <FormBox>
                                                <dt>
                                                    Start Date<strong>*</strong>
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <StyledDateInput >
                                                                <PlItem
                                                                    className={!isEmpty(item?.startDate) ? "on" : ""}
                                                                >
                                                                    <input type="text"
                                                                           placeholder={"Enter job start date"}
                                                                           required={true}
                                                                           value={!isEmpty(item?.startDate) ? item?.startDate.slice(0,10) : ""}
                                                                    />
                                                                    <DateIcon/>
                                                                </PlItem>
                                                                <input type="date"
                                                                       value={item?.startDate}
                                                                       onChange={(e)=>{
                                                                           const value = e.target.value;
                                                                           const dateData = dayjs(value).format("YYYY-MM-DD")
                                                                           // const dateData = dayjs(value).format("YYYY-MM-DD")
                                                                           console.log("@value",dateData);
                                                                           onChangeData(exp,index,"startDate", setExp, dateData)
                                                                       }}
                                                                />
                                                            </StyledDateInput>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                        <Col >
                                            <FormBox>
                                                <SpacingV className={"mobile"} height={15} />
                                                <dt>
                                                    End Date<strong>*</strong>
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <StyledDateInput >
                                                                <PlItem
                                                                    className={!isEmpty(item?.endDate) ? "on" : ""}
                                                                >
                                                                    <input type="text"
                                                                           placeholder={"Enter job end date"}
                                                                           required={true}
                                                                           value={!isEmpty(item?.endDate) ? item?.endDate.slice(0,10) : ""}
                                                                    />
                                                                    <DateIcon/>
                                                                </PlItem>
                                                                <input type="date"
                                                                       value={item?.endDate}
                                                                       onChange={(e)=>{
                                                                           const value = e.target.value;
                                                                           const dateData = dayjs(value).format("YYYY-MM-DD")
                                                                           // const dateData = dayjs(value).format("YYYY-MM-DD")
                                                                           console.log("@value",dateData);
                                                                           onChangeData(exp,index,"endDate", setExp, dateData)
                                                                       }}
                                                                />
                                                            </StyledDateInput>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>
                                    <Row display={"flex"} style={{width: "100%"}}>
                                        <Col style={{width: "100%",}}>
                                            <FormBox>
                                                <dt>
                                                    Description
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <textarea
                                                                    value={item?.description}
                                                                    onChange={(e)=>{
                                                                        const value = e.target.value
                                                                        onChangeData(exp,index,"description", setExp, value)
                                                                    }}
                                                                    style={{resize:"none", height:90}} placeholder={"Describe something about your role and responsibilities in company"} />
                                                            </FormItem>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>
                                </ContentBox>
                                {
                                    index !== 0 &&
                                    <RemoveItem
                                        onClick={()=>{
                                            const c = cloneDeep(exp);
                                            c.splice(index, 1);
                                            setExp(cloneDeep(c))
                                        }}
                                    >
                                        <CloseIcon/>
                                    </RemoveItem>
                                }
                                <ContentBox>
                                    <AddChapter
                                        style={{

                                        }}
                                        onClick={() => {
                                            const c = cloneDeep(exp);
                                            c.splice(index + 1, 0, expObj);
                                            setExp(cloneDeep(c))
                                        }}
                                    >
                                        <span>Add</span>
                                        <PlusIcon />
                                    </AddChapter>
                                </ContentBox>
                            </ExperienceItem>
                        )
                    })
                }
            </Experience>

            <Skills>
                <ContentBox>
                    <h1>
                        Skills & Certificates
                    </h1>
                </ContentBox>
                <ContentBox>
                    {
                        skill.map((item, index) => {
                            return(
                                <SkillsItem>
                                    <Row style={{width: "100%", alignItems:"center",  marginBottom:8}} display={"flex"}>
                                        <Col className={"col"} style={{width: "calc(100% - 52px)"}}>
                                            <FormBox style={{width:"100%"}}>
                                                <dd  style={{width:"100%"}}>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <FormItem className={"formItem"}>
                                                                <input type="text"
                                                                       value={item}
                                                                       onChange={(e) => {
                                                                           const c = cloneDeep(skill);
                                                                           c[index] = e.target.value;
                                                                           setSkill(c)
                                                                       }}
                                                                       placeholder={"Add any skills or certificate you have or you earn from courses or work in companies"}/>
                                                            </FormItem>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                            {
                                                index !== 0 &&
                                                <div
                                                className={"removeSkillsMobile"}
                                                style={{display: "flex", alignItems: "center"}}
                                                onClick={() => {
                                                    const c = cloneDeep(skill);
                                                    c.splice(index, 1);
                                                    setSkill(c)
                                                }}
                                            >
                                                <RemoveGrey/>
                                            </div>
                                            }
                                        </Col>
                                        {
                                            index !== 0 &&
                                            <div
                                                className={"removeSkills"}
                                                style={{display: "flex", alignItems: "center"}}
                                                onClick={() => {
                                                    const c = cloneDeep(skill);
                                                    c.splice(index, 1);
                                                    setSkill(c)
                                                }}
                                            >
                                            <RemoveGrey/>
                                            </div>
                                        }
                                    </Row>
                                </SkillsItem>
                            )
                        })
                    }
                </ContentBox>
                <ContentBox>
                    <AddChapter
                        onClick={() => {
                            const c = cloneDeep(skill);
                            c.push("");
                            setSkill(c)
                        }}
                    >
                        <span>Add</span>
                        <PlusIcon/>
                    </AddChapter>
                </ContentBox>
            </Skills>
            <Edu>
                <ContentBox>
                    <h1 style={{marginBottom:15}}>
                        Education
                    </h1>
                </ContentBox>
                {
                    edu.map((item, index) => {
                        return(
                            <EduItem
                                className={index !== 0 ? "border" : ""}
                            >
                                <ContentBox>
                                    <Row display={"flex"} style={{width: "100%"}}>
                                        <Col style={{width: "100%"}}>
                                            <FormBox>
                                                <dt>
                                                    School Name
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <input type="text"
                                                                       value={item.schoolName}
                                                                       onChange={(e)=>{
                                                                           const value = e.target.value;
                                                                           onChangeData(edu, index, "schoolName", setEdu, value)
                                                                       }}
                                                                       placeholder={"Enter your school name in which you study"}/>
                                                            </FormItem>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>
                                    <Row display={"flex"} style={{width:"100%"}}>
                                        <Col>
                                            <FormBox>
                                                <dt>
                                                    Start Date
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <StyledDateInput >
                                                                <PlItem
                                                                    className={!isEmpty(item?.startedDate) ? "on" : ""}
                                                                >
                                                                    <input type="text"
                                                                           placeholder={"Enter start date"}
                                                                           value={!isEmpty(item?.startedDate) ? item?.startedDate.slice(0,10) : ""}
                                                                    />
                                                                    <DateIcon/>
                                                                </PlItem>
                                                                <input type="date"
                                                                       value={item?.startedDate}
                                                                       onChange={(e)=>{
                                                                           const value = e.target.value;
                                                                           const dateData = dayjs(value).format("YYYY-MM-DD")
                                                                           console.log("@value",dateData);
                                                                           onChangeData(edu,index,"startedDate", setEdu, dateData)
                                                                       }}
                                                                />
                                                            </StyledDateInput>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                        <Col >
                                            <FormBox>
                                                <SpacingV className={"mobile"} height={15} />
                                                <dt>
                                                    End Date
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <StyledDateInput >
                                                                <PlItem
                                                                    className={!isEmpty(item?.endedDate) ? "on" : ""}
                                                                >
                                                                    <input type="text"
                                                                           placeholder={"Enter end date"}
                                                                           value={!isEmpty(item?.endedDate) ? item?.endedDate.slice(0,10) : ""}
                                                                    />
                                                                    <DateIcon/>
                                                                </PlItem>
                                                                <input type="date"
                                                                       value={item?.endedDate}
                                                                       onChange={(e)=>{
                                                                           const value = e.target.value;
                                                                           const dateData = dayjs(value).format("YYYY-MM-DD")
                                                                           console.log("@value",dateData);
                                                                           onChangeData(edu,index,"endedDate", setEdu, dateData)
                                                                       }}
                                                                />
                                                            </StyledDateInput>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>

                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>

                                    <Row display={"flex"} style={{width:"100%"}}>

                                        <Col  >
                                            <FormBox>
                                                <dt>
                                                    Degree Type
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <AutoComplete
                                                                options={cloneDeep(degreeList)}
                                                                placeholder={"Please enter your position (e.g Digital Marketing)"}
                                                                value={item?.degreeType1}
                                                                required={false}
                                                                formType={true}
                                                                onChange={(value)=>{
                                                                    onChangeData(edu,index,"degreeType1", setEdu, value)
                                                                }}
                                                            />
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                        <Col>
                                            <FormBox>
                                                <SpacingV className={"mobile"} height={15} />
                                                <dt>
                                                    Field of Study
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <input type="text"
                                                                       style={{height:48}}
                                                                       value={item.degreeType2}
                                                                       onChange={(e)=>{
                                                                           const value = e.target.value;
                                                                           onChangeData(edu, index, "degreeType2", setEdu, value)
                                                                       }}
                                                                       placeholder={"Enter field type (e.g Information Technology)"}/>
                                                            </FormItem>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>

                                    </Row>
                                    <Row display={"flex"} style={{width:"100%"}}>
                                        <Col style={{width:"100%", }} >
                                            <FormBox>
                                                <dt>
                                                    Description
                                                </dt>
                                                <dd>
                                                    <ProfileFormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                            <textarea style={{resize:"none", height:90}}
                                                                      value={item.description}
                                                                      onChange={(e)=>{
                                                                          const value = e.target.value;
                                                                          onChangeData(edu, index, "description", setEdu, value)
                                                                      }}
                                                                      placeholder={"Describe something about your study and field in institue"}
                                                            />
                                                            </FormItem>
                                                        </li>
                                                    </ProfileFormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>
                                </ContentBox>
                                {
                                    index !== 0 &&
                                    <RemoveItem
                                        onClick={()=>{
                                            const c = cloneDeep(edu);
                                            c.splice(index, 1);
                                            setEdu(cloneDeep(c))
                                        }}
                                    >
                                        <CloseIcon/>
                                    </RemoveItem>
                                }
                                <ContentBox>
                                    <AddChapter
                                        onClick={() => {
                                            const c = cloneDeep(edu);
                                            c.splice(index + 1, 0, eduObj);
                                            setEdu(c);
                                        }}
                                    >
                                        <span>Add</span>
                                        <PlusIcon />
                                    </AddChapter>
                                </ContentBox>
                            </EduItem>
                        )
                    })
                }
            </Edu>

        </ContentsInner>
        <ContentBox
            style={{
                justifyContent:"flex-end",
                display:"flex"
            }}>
            <AddChapter
                style={{marginRight:10}}
                /*onClick={() => {
                    patchProfile();
                }}*/
            >
                <button
                    type={"submit"}
                    style={{marginRight:0}}>Save</button>
            </AddChapter>
            <AddChapter

                // onClick={() => {
                //     patchProfile();
                // }}
            >
                <button
                    type={"submit"}
                    style={{marginRight:0}}>Publish</button>
            </AddChapter>
        </ContentBox>
    </Contents>

  </Container>
)

}
const Container = styled.form`
    dt{
        font-family: Europa;
    }
    &.admin{
        .commonContents{
            box-shadow: none!important;
        }    
        .commonContentsHeader{
            background: #fff;
            border-bottom: solid 1px #ddd;
        }
    }
    
    .mobile{
        display: none;
        @media screen and (max-width: 768px) {
            display: block;
        }
    }
`;

export default AuthorProfile;
const ContentsInner = styled.div`
   padding: 30px 0px;
 
   h1{
       font-family: Europa-Bold;
       font-size: 18px;
       font-weight: 700;
       line-height: 24px;
       letter-spacing: 0em;
       text-align: left;
       color: #DDC160;
   }
    .commonContents{
        width: 450px!important;
    }
`
const ProfileHeader = styled.div`
   display: flex;
   padding: 0 20px;
   width: 100%;
    @media screen and (max-width: 768px) {
        flex-direction: column;
       
    }
   input{
       width: 100%;
   }
`
const ContentBox = styled.div`
   padding: 0 20px;
`
const Thumb = styled.div`
    margin-right: 18px;
    @media screen and (max-width: 768px) {
        margin-right: 0px;
    }
    > dt {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        opacity: 0.8;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`
const Img = styled.div`
   width: 138px;
   height: 138px;
   background: #eee;
   position: relative;
   cursor: pointer;
    display: flex;
    border-radius: 8px;
    border: solid 1px #eee;
    .cam{
        display: none;
    }
   @media screen and (max-width: 768px) {
       width: calc(100% - 52px);
       margin-bottom: 15px;
       .cam{
           top: 50%;
           transform: translateY(-50%);
           cursor: pointer;
           position: absolute;
           left: calc(100% + 20px);
           width: 36px;
           display: flex;
           align-items: center;
           justify-content: center;
           height: 36px;
           border-radius: 100%;
           background: #FFFFFF;
           box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.06);
       }
   }
   img{
       border: none!important;
       width: 100%;
       height: 100%;
       object-fit: cover;
       border-radius: 8px;
       
   }
   input{
       
       cursor: pointer;
       width: 100%;
       height: 100%;
       position: absolute;
       opacity: 0;
       z-index: 9;
   }
    .userIcon{
        padding: 10px;
        width: 100%;
        height: 100%;
        color: #ddd;
    }
`
const HeaderContents = styled.div`
   width: 100%;
`
const Experience = styled.div`

`
const ExperienceItem = styled.div`
    padding-top: 20px;
    position: relative;
    &.border {
        border-top: 1px solid transparent;
        padding-top: 45px;
        border-image: url("/images/line.png") 10 repeat;
    }
    .checkItem{
        /* I am currently working in the role here */
        
        cursor: pointer;
        display: flex;
       span{
           margin-left: 10px;
           font-family: 'Europa-Regular';
           font-style: normal;
           font-weight: 400;
           font-size: 14px;
           line-height: 16px;
           /* identical to box height, or 114% */
           display: flex;
           align-items: center;

           color: #333333;
       }

      
        
    }
    padding-bottom: 10px;
    
`
const RemoveItem = styled.div`
   width: 51px;
   background: #333; 
   height: 25px;
   position: absolute; 
   right: 0;
   top: 0;
   display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`
const Skills = styled.div`
   border-top:solid 0.6px #3333334D;
   padding-top: 30px;
   padding-bottom: 20px;  
`
const SkillsItem = styled.div`
    @media screen and (max-width: 768px) {
        .removeSkills{
            display: none!important;
        }    
    }
   .col{
       .removeSkillsMobile{
           display: none!important;
       }
       display: flex;
       flex-direction: row;
       align-items: center;
       justify-content: space-between!important;
   
       @media screen and (max-width: 768px) {
           width: 100% !important;
           .formItem{
               margin-right: 10px;
           }
           .removeSkillsMobile{
               display: flex!important;
               svg{
                   width: 20px;
                   height: 20px;
               }
           }
       }
       input{
           width: 100% !important;
       }
   }

`
const Edu = styled.div`
    padding-top: 30px;
    padding-bottom: 20px;
    border-top:solid 0.6px #3333334D;
`
const EduItem = styled.div`
    position: relative;
    &.border {
        border-top: 1px solid transparent;
        padding-top: 45px;
        border-image: url("/images/line.png") 10 repeat;
    }
    padding-bottom: 10px;
`

const StyledDateInput = styled(FormItem)`
  position: relative;
    input{
        @media screen and (max-width: 768px) {
            outline: none!important;
        }
    }
    @media screen and (max-width: 768px) {
        
        height: 48px;
    }
`;

const PlItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    position: absolute;
    width: calc(100% - 5px);
    content: "abc";
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: rgba(51, 51, 51, 0.20);

    @media screen and (max-width: 768px) {
        width: calc(100%);
        border: solid 1px #3333334D;

        height: 48px;
        input{
            outline: none!important;
        }
    }
    
    & > div{
        border: none!important;
        box-shadow: none!important;
    }
    &.on{
        color: #333;
    }
    box-shadow: none!important;
    input{
        @media screen and (max-width: 768px) {
         outline: none!important;
        }
        box-sizing: border-box!important;
        
        border: none!important;
        outline: none!important;
        box-shadow: none!important;
        padding: 0;
        border: none;
        font-family: Europa-Regular;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0em;
        text-align: left;
        border-radius: 8px;
        padding: 12px 0px;
        height: calc(100% - 5px);
        //border: solid 1px red!important;
        pointer-events: none;
        &::placeholder {
            color: #ddd;
        }
    }
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    border-radius: 8px;
    padding: 12px 16px;
    height: calc(100% - 5px);
    pointer-events: none;
`
const RowContents = styled.div`
   display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    height: 175px;
    border-radius: 20px;
    border: 0.6px solid rgba(51, 51, 51, 1);
    position: relative;
    
    svg{
        opacity: 0.6;
    }
    a{
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 999;
    }
    img{
        object-fit: contain;
        width: 130px;
        height: 130px;
    }
    span{
        
        width: 100px;
        /* Body/Primary/State3 */
        margin-top: 5px;
        /* Auto layout */
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 6px 12px!important;
        justify-content: center;
        background: #333333;
        box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.08);
        border-radius: 4px;


        /* Go to Profile */
        
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        /* identical to box height, or 117% */
        letter-spacing: 0.02em;

        color: #FFFFFF;
        

    
    }
`
const RowWrap = styled.div`
   display: flex;
    padding-right: 20px;
`

const ImgPopup = styled.div`
    opacity: 0;
    transform: translateY(10px);
    border-radius: 22px;
    position: relative;
    overflow: hidden;
    height: 450px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &.on{
        opacity: 1;
        transform: none;
    }
    .close{
        cursor: pointer;
        svg{
           width: 28px;
            height: 28px;
        }
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 9999;
    }
    img{
        left: 50%;
        top: 47%;
        width: 237px;
        height: 237px;
        position: absolute;
        object-fit: cover;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
    }
    input{
        left: 50%;
        top: 47%;
        width: 237px;
        height: 237px;
        position: absolute;
        object-fit: cover;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        zIndex:999;
        opacity: 0;
    }
    .userIcon{
        border: solid 1px #000;
        color: #ddd;
        left: 50%;
        top: 47%;
        opacity: 0.7;
        width: 237px;
        height: 237px;
        position: absolute;
        z-index: 0;
        object-fit: cover;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
    }
    .btns{
        width: 100%;
        display: flex;
        justify-content: space-between;
        .inputItem{
            width: calc((100% - 20px) / 2);
            display: flex;
            position: relative;
            cursor: pointer;
            input{
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 9;
                opacity: 0;
            }
            span{
                width:100%;
                display: flex;

            }
        }
        span{
            border-radius: 6px;
            cursor: pointer;
            height: 45px;
            align-items: center;
            justify-content: center;
            display: flex;
            width: calc((100% - 20px) / 2);
            border: solid 1px rgba(51, 51, 51, 1);
            &.uploadBtn{
                background: #333;
                color: #fff;
            }
        }
        padding: 22.5px;
    }
`
const ImgPopupItem = styled.div`
   display: flex;
   flex-direction: column;
    img{
        border: solid 1px #333;
    }
`
const WarnPopup = styled.div`
   background: rgba(255, 255, 255, 1);
    width: 380px;
    border-radius: 10px;
    overflow: hidden;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    box-shadow: -1px 1px 4px 0px #3333331F;
    
    p{
        font-family: Europa-Regular;
        font-size: 20px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 35px;
        margin-top: 35px;
        text-align: center;
    }
`
const PopupBtn = styled.div`
   display: flex;
   align-items: center;
    justify-content: center;
    
   span{
       display: flex;
       cursor: pointer;
       width: 120px;
       height: 45px;
       border-radius: 4px;
       border: solid 1px #111;
       align-items: center;
       justify-content: center;
       margin: 0 10px;
   }
`